
<template>
  <!--门禁设备-->
  <div>
    <section class="dev-info">
      <div class="dev-num">
        <div>
          <div>
            <p>设备总数</p>
            <span>{{devStatist.device_count}}</span>
          </div>
        </div>
        <div>
          <div>
            <p>当前在线</p>
            <span>{{devStatist.device_online}}</span>
          </div>
        </div>
      </div>
      <a-button @click="DeviceStatus('update')" type="primary" :loading="refreshLoading.loading">刷新</a-button>
    </section>

   <x-tabula
     :style="{backgroundColor: '#fff', padding: '24px'}"
     ref="table"
    :dataSource="dataSource"
     rowKey="device_id"
    :searchList="searchList"
    :columns="columns"
    :tableOptList="tableOptList"
    :rowOptList="rowOptList"
    :searchParams.sync="searchParams"
    :listApi="listApi"
     :addHandleParam="addHandleParam"
    :deleteParam="deleteParam"
    :rowSelection="true"
  >
  </x-tabula>

    <!--选择重启类型的弹窗-->
    <a-modal
      title="请选择重启类型"
      :visible="visible"
      @ok="confirm"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="form">
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="重启类型">
          <a-select
            v-decorator="['type', { rules: [{ required: true, message: '请选择重启类型' }] }]"
            placeholder="请选择重启类型">
            <a-select-option
              v-for="(item, index) of restartType"
              :key="index"
              :value="item.value"
              :disabled="item.disabled">{{item.label}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <!--获取日志的弹窗-->
    <a-modal
      title="获取日志"
      :visible="logModal"
      @ok="handleSubmit"
      @cancel="logModal=false"
      :confirmLoading="btnLoading.loading"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="logForm">
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="日志内容">
          <a-input v-decorator="['content', { rules: [{required: true, message: '请输入日志内容' }]}]" placeholder="请输入日志内容"></a-input>
        </a-form-item>
      </a-form>
    </a-modal>

    <!--远程调试的弹窗-->
    <a-modal
      title="远程调试"
      :visible="debugVisible"
      @cancel="closeDebugModal"
      :width="700"
      :footer="null"
      v-bind="$store.state.modalConfig"
    >
      <a-form :form="debugForm">
        <a-form-item label="请求参数" v-bind="$store.state.modal_ItemLayout">
          <div :style="{display: 'flex', justifyConte: 'space-between'}">
            <a-input @change="reqParamChange" v-decorator="['content']" placeholder="请输入请求参数"/>
            <a-button :style="{marginLeft: '10px'}" v-if="!debugSuccess" @click="reqDebugging" :loading="btnLoading.loading" type="primary">提交参数</a-button>
            <a-button :style="{marginLeft: '10px'}" v-else @click="getDebugResult(debugTime)" :loading="btnLoading.loading" type="primary">获取结果</a-button>
          </div>
        </a-form-item>

        <a-form-item label="响应结果" v-bind="$store.state.modal_ItemLayout">
        <a-textarea v-decorator="['resContent']" rows="4" :placeholder="resTip"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'smartDoor',
  data () {
    return {
      debugTime: '',
      debugSuccess: false,
      resTip: '响应结果',
      debugVisible: false,
      logModal: false,
      snCode: '',
      visible: false,
      btnLoading: { loading: false },
      refreshLoading: { loading: false },
      devStatist: {
        device_count: '',
        device_online: ''
      },
      restartType: [
        { label: '系统', value: 1 },
        { label: 'apk', value: 2 }
      ],

      /** table 参数 */
      searchList: [
        { props: ['community_id'], placeholder: '小区名称', options: [], inputType: 'select' },
        { props: ['keywords'], placeholder: '设备名称、编码', options: [], inputType: 'input' },
        { props: ['product_type'], placeholder: '产品型号', options: [], inputType: 'select' },
        { props: ['online'], placeholder: '在线状态', options: [], inputType: 'select' },
        { props: ['area_id'], placeholder: '省市', options: [], inputType: 'cascader', changeOnSelect: true },
        { props: ['property_id'], placeholder: '物业', options: [], inputType: 'select' },
        { props: ['create_date'], placeholder: ['添加时间', '添加时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '生成云对讲账户', icon: 'phone', disabled: true, handle: this.createTalkAccount, key: 'createAccount' },
        { text: '删除', icon: 'close', disabled: true, handle: '', key: 'batchDel' },
        { text: '初始化设备', icon: 'tool', disabled: true, handle: this.initDevice, key: 'batchInit' },
        { text: '同步数据', icon: 'sync', disabled: true, handle: this.resetDevice, key: 'reset' },
        { text: '同步人脸', icon: 'smile', disabled: true, handle: this.syncFace, key: 'syncFace' }
      ],
      rowOptList: [
        { text: '详情', handle: (row) => this.toDetail(row.device_id), key: 'detail' },
        { text: '修改', handle: (row) => this.$children[1].toEdit(row), key: 'edit' },
        { text: '初始化设备', handle: (row) => this.initDevice(row.device_id), key: 'init' },
        [
          { text: '重启', handle: (row) => this.openModal(row), key: 'restart' },
          { text: '升级', handle: (row) => this.upDate(row), key: 'update' },
          { text: '删除', handle: (row) => this.$children[1].showDeleteConfirm(row), key: 'delete' },
          { text: '获取日志', handle: (row) => this.openLogModal(row), key: 'log' },
          { text: '远程调试', handle: (row) => this.openDebugModal(row), rowOptDisHandle: this.disabledDebug, key: 'debug' }
        ]
      ],
      columns: [
        { title: 'ID', dataIndex: 'device_id', align: 'left', width: '' },
        { title: '位置', dataIndex: 'position_name', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'device_name', align: 'left', width: '' },
        { title: '设备编码', dataIndex: 'device_sncode', align: 'left', width: '' },
        { title: '产品型号', dataIndex: 'product_type', align: 'left', width: '' },
        { title: '当前版本', dataIndex: 'version', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_txt', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        community_id: undefined,
        keywords: undefined,
        product_type: undefined,
        online: undefined,
        area_id: undefined,
        property_id: undefined,
        create_date: undefined
      },
      listApi: {
        url: '/smart_door_eq',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'editSmartDoor',
        title: '编辑门禁'
      },
      deleteParam: {
        url: '/smart_door_eq',
        param: {pk_key: 'device_id', pk_val: ''},
        title: '门禁设备',
        key: 'device_name'
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
    this.logForm = this.$form.createForm(this);
    this.debugForm = this.$form.createForm(this);
  },
  created () {
    this.DeviceStatus();
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /** 同步人脸 */
    syncFace (ids, rows) {
      this.$post({
        url: '/smart_door_eq/remote_face',
        params: { device_id: ids.join(',') }
      }).then(({data}) => {
        this.$message.success('同步成功');
        this.$refs.table.getTableList();
      });
    },
    /** 判断是否禁用远程调试选项 */
    disabledDebug (row) {
      let productType = row.product_type;
      if (!(productType && productType[0] === 'B')) {
        return true;
      }
    },
    /** 请求参数 change事件 */
    reqParamChange (e) {
      this.debugSuccess = false;
      this.debugTime = '';
    },
    /** 关闭调试窗口 */
    closeDebugModal () {
      this.debugVisible = false;
      this.debugSuccess = false;
      this.debugTime = '';
    },
    /** 打开调试弹窗 */
    openDebugModal (row) {
      if (row.product_type[0] === 'B') {
        this.snCode = row.device_sncode;
        this.debugVisible = true;
      }
    },
    /** 远程调试 */
    reqDebugging () {
      this.debugForm.resetFields(['resContent']);
      this.debugForm.validateFields((err, values) => {
        if (err) { return; }
        this.$post({
          url: '/smart_door_eq/debugging',
          params: {
            device_sncode: this.snCode,
            ...values
          },
          btnLoading: this.btnLoading
        }).then(({data}) => {
          this.debugTime = data.debug_time;
          this.getDebugResult(data.debug_time);
          this.debugSuccess = true;
        }).catch(() => {
        });
      });
    },
    /** 获取debug结果 */
    getDebugResult () {
      this.resTip = '等待响应...';
      this.$get({
        url: '/smart_door_eq/debug_result',
        params: {
          device_sncode: this.snCode,
          debug_time: this.debugTime
        },
        btnLoading: this.btnLoading
      }).then(({data}) => {
        setTimeout(() => {
          this.resTip = '响应结果';
          this.debugSuccess = false;
          this.debugForm.setFieldsValue({ resContent: data.content });
        }, 300);
      }).catch(() => {
        this.resTip = '响应结果';
      });
    },
    /* 初始化设备 */
    initDevice (id) {
      this.$confirm({
        title: '确定要初始化设备？',
        centered: true,
        onOk: () => {
          if (Array.isArray(id)) {
            id = id.join(',');
          }
          this.$post({
            url: '/smart_door_eq/seeting/reset',
            params: { device_id: id }
          }).then((res) => {
            this.$message.success('初始化成功！');
          });
        }
      });
    },
    /* 同步数据 */
    resetDevice (selectedId, selectedRows) {
      let ids = selectedId.join(',');
      this.$confirm({
        title: `你确实要重置这${selectedId.length}台设备？`,
        centered: true,
        onOk: (close) => {
          close();
          this.$post({
            url: '/smart_door_eq/remote_active',
            params: { device_id: ids }
          }).then((res) => {
            this.$message.success('设备重置成功');
          });
        }
      });
    },
    /* 获取下拉 */
    getSelect () {
      this.communitySelect(0, 'searchList', 1);
      this.regionSelect(4);
      this.propertySelect(5);
      let paramArr = [
        {index: 2, key: 'product_type', scope: 'searchList'},
        {index: 3, key: 'online_status', scope: 'searchList'}
      ];
      this.deviceManageSelect(paramArr);
    },
    /* 获取设备状态 */
    DeviceStatus (update) {
      let paramObj = {
        url: '/smart_door_eq/statist',
        params: {}
      };
      update && (paramObj.btnLoading = this.btnLoading);
      this.$get(paramObj).then(({data}) => {
        this.devStatist = data;
        this.$children[1].getTableList();
        if (update) {
          this.$message.success('设备状态同步成功！');
        }
      }).catch(() => {
        this.$children[1].getTableList();
      });
    },
    /* 生成云对讲账户 */
    createTalkAccount (id) {
      id = id.join(',');
      this.$post({
        url: '/smart_door_eq/account',
        params: { door_eq_ids: id }
      }).then((res) => {
        this.$message.success(`${res.msg}`);
      });
    },
    /* 进入详情页面 */
    toDetail (id) {
      this.$router.push({
        name: 'smartDoorDetail',
        query: { id: id }
      });
    },
    /* 打开弹窗 */
    openModal (row) {
      this.snCode = row.device_sncode;
      let apk = this.restartType[1];
      let productType = row.product_type;
      productType && productType[0] === 'B' ? apk.disabled = true : apk.disabled = false;
      this.visible = true;
    },
    /* 点击确定弹窗 */
    confirm () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        let param = {
          device_sncode: this.snCode,
          ...values
        };
        this.$post({
          url: '/smart_door_eq/boot',
          params: param
        }).then((res) => {
          this.$message.success('重启成功！');
          this.visible = false;
        });
      });
    },
    /* 升级设备 */
    upDate (row) {
      this.$confirm({
        title: `检测到最新版本${row.new_version}，确定升级吗？`,
        centered: true,
        onOk: () => {
          this.$post({
            url: '/smart_door_eq/promotion',
            params: { device_sncode: row.device_sncode }
          }).then((res) => {
            this.$message.success('升级成功！');
            this.$children[1].getTableList();
          });
        }
      });
    },
    /** 打开获取日志弹窗 */
    openLogModal (record) {
      this.snCode = record.device_sncode;
      if (record.product_type[0] === 'B') {
        this.handleSubmit('blackBox');
      } else {
        this.logModal = true;
      }
    },
    /** 获取日志 */
    handleSubmit (blackBox) {
      if (blackBox === 'blackBox') {
        this.fetchLog();
      } else {
        this.logForm.validateFields((err, values) => {
          if (err) { return; }
          this.fetchLog(values);
        });
      }
    },
    /** 获取日志 */
    fetchLog (values = {}) {
      this.$post({
        url: '/smart_door_eq/uploadlog',
        params: {
          device_sncode: this.snCode,
          content: values.content
        },
        btnLoading: this.btnLoading
      }).then(({data}) => {
        this.$message.success('获取日志成功');
        this.logModal = false;
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/device/smartDoor/smartDoor.vue